import {ActionReducerMap, MetaReducer} from '@ngrx/store';

import {
  refDataInitialState,
  refDataReducer,
  requestRefDataFeatureKey,
  RequestRefDataState,
} from './ref-data/refdata.reducer';
import {
  substituteFeatureKey,
  substituteInitialState,
  substituteReducer,
  SubstituteState,
} from './substitute/substitute.reducer';
import {userFeatureKey, userInitialState, userReducer, UserState} from './user/user.reducer';

// tslint:disable-next-line:no-empty-interface
export interface State {
  [userFeatureKey]: UserState;
  [requestRefDataFeatureKey]: RequestRefDataState;
  [substituteFeatureKey]: SubstituteState;
}

export const reducers: ActionReducerMap<State> = {
  [userFeatureKey]: userReducer,
  [requestRefDataFeatureKey]: refDataReducer,
  [substituteFeatureKey]: substituteReducer
};

export const initialState = {
  [userFeatureKey]: userInitialState,
  [requestRefDataFeatureKey]: refDataInitialState,
  [substituteFeatureKey]: substituteInitialState
};

export const metaReducers: MetaReducer<State>[] = [];
